'use client';

import { c as _c } from "react/compiler-runtime";
import { ErrorBoundary } from '@sentry/nextjs';
import { QueryClientProvider } from '@systemeio/file-manager';
import { fixFailedToExecuteRemoveChildOnNode } from '@systemeio/util';
import { GrowthbookClientProvider } from 'growthbook/client';
import type { PropsWithChildren } from 'react';
import { ToastProvider } from 'shared/components';
import { META_DATA_FROM_SERVER_KEY, MetaDataFromServerInterface } from 'shared/hooks/use-metadata-from-server';
import { useRouter } from 'shared/hooks/use-router';
import { SWRConfig } from 'swr';
import { LocaleProviders } from './locale-providers';
import { TouchDeviceProvider } from './touch-device-provider';
fixFailedToExecuteRemoveChildOnNode();
interface RootProvidersProps extends PropsWithChildren, MetaDataFromServerInterface {}
export function RootProviders(t0) {
  const $ = _c(11);
  const {
    children,
    hostOnServer,
    serverDeviceType
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== hostOnServer || $[1] !== serverDeviceType) {
    t1 = {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      onErrorRetry: _temp,
      fallback: {
        [META_DATA_FROM_SERVER_KEY]: {
          hostOnServer,
          serverDeviceType
        }
      }
    };
    $[0] = hostOnServer;
    $[1] = serverDeviceType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children) {
    t2 = <QueryClientProvider><ToastProvider><TouchDeviceProvider>{children}</TouchDeviceProvider></ToastProvider></QueryClientProvider>;
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== router.asPath || $[6] !== t2) {
    t3 = <LocaleProviders><GrowthbookClientProvider currentPath={router.asPath}>{t2}</GrowthbookClientProvider></LocaleProviders>;
    $[5] = router.asPath;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <ErrorBoundary><SWRConfig value={t1}>{t3}</SWRConfig></ErrorBoundary>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(error, key, config, revalidate, t0) {
  const {
    retryCount
  } = t0;
  if (retryCount > 3) {
    if (error.status === 502 || error.status === 504) {
      return;
    }
  }
}